import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'helpers/GlobalHelper';
import {
  setDisableRender as setGlobalVideoDisabled,
  setScreenInControlOfState as setGlobalVideoControl,
  setPortalRef as setGlobalPortalRef,
  setPortalContentFinished as setGlobaPortalContentFinished,
  setVideoPanel as setGlobalVideoPanel,
} from 'components/VideoPlayerGlobal/Actions';
import Icon from 'components/Icon';
import { PAGE_SERIES_DETAIL } from 'helpers/PageHelper';
import { getActivePlayer, getPlayerState } from 'helpers/PlayerHelper';
import {
  callSegmentPlayerEvent,
  SegmentPlayerStates,
  SegmentVideoEvents,
} from '@foxcorp/delta-web-analytics';
import ContextPromo from './ContextPromo';

import Style from './ContextPlayer.module.scss';

const ContextPlayer = ({
  isMobile,
  isPortalContentFinished,
  onClickCTA,
  onClose,
  playerControlState,
  portalRef,
  promo,
  promoDisabled,
  setGlobalPortalRef,
  setGlobaPortalContentFinished,
  setGlobalVideoControl,
  setGlobalVideoDisabled,
  setGlobalVideoPanel,
  video,
  visibility,
}) => {
  const videoRefLoc = 'context-player-video-portal';
  const modalRef = useRef();
  const [prevControlState, setControlState] = useState(playerControlState);
  const { upsellPromoNavCTA: PromoCTA } = window.Language;
  const CTA = PromoCTA;
  const startVideo = () => {
    setGlobalPortalRef(videoRefLoc);
    if (video) setGlobalVideoPanel({ video, source: PAGE_SERIES_DETAIL });
    setGlobalVideoDisabled({ value: false, source: PAGE_SERIES_DETAIL });
    setControlState(playerControlState);
  };
  const endVideo = () => {
    setGlobaPortalContentFinished(false);
    setGlobalPortalRef('');
    setGlobalVideoDisabled({ value: true, source: PAGE_SERIES_DETAIL });
  };
  const closeAndEndVideo = () => {
    setGlobalPortalRef('');
    setGlobalVideoDisabled({ value: true, source: PAGE_SERIES_DETAIL });
    onClose();
  };
  useEffect(() => {
    if (!visibility) return () => {};
    if (prevControlState !== null) setGlobalVideoControl(null);
    if (!portalRef) {
      startVideo();
    } else {
      endVideo();
    }
    return () => endVideo();
  }, [visibility]);
  useEffect(() => {
    if (isPortalContentFinished) {
      closeAndEndVideo();
    }
  }, [isPortalContentFinished]);
  if (!visibility) return null;

  const handleOverlayClick = e => {
    if (modalRef.current.contains(e.target)) {
      return null;
    }
    if (getPlayerState(getActivePlayer()) === 'PLAYING') {
      callSegmentPlayerEvent({
        eventName: SegmentVideoEvents.videoPlaybackInterrupted,
        props: {
          method: 'player closed',
          video_player_state: SegmentPlayerStates.PAUSE,
        },
      });
    }
    onClose();
    return e;
  };
  const modalStyle = classNames(Style.modalOverlay, 'modal-open');
  const renderPromoBanner = () =>
    !isMobile &&
    !promoDisabled && (
      <ContextPromo {...promo} promoCTA={promo.promoCTA || CTA} onClickCTA={onClickCTA} />
    );
  const renderCTA = () =>
    isMobile &&
    !promoDisabled && (
      <div className={Style.CTA}>
        <button className={Style.btn} onClick={onClickCTA}>
          {promo.promoCTA || CTA}
        </button>
      </div>
    );
  const contextPlayer = (
    <div className={modalStyle} onClick={handleOverlayClick}>
      <div className={Style.closeButton} onClick={onClose}>
        <Icon icon="close" color="white" size="large" />
      </div>
      <div ref={modalRef} className={Style.modal}>
        <div className={Style.video} id={videoRefLoc} />
        {renderPromoBanner()}
        {renderCTA()}
      </div>
    </div>
  );
  return ReactDOM.createPortal(contextPlayer, document.getElementById('app-root'));
};

ContextPlayer.defaultProps = {
  isMobile: false,
  isPortalContentFinished: false,
  onClickCTA: noop,
  onClose: noop,
  playerControlState: null,
  portalRef: '',
  promo: {},
  promoDisabled: false,
  setGlobalPortalRef: noop,
  setGlobaPortalContentFinished: noop,
  video: null,
  visibility: false,
};

ContextPlayer.propTypes = {
  isMobile: PropTypes.bool,
  isPortalContentFinished: PropTypes.bool,
  onClickCTA: PropTypes.func,
  onClose: PropTypes.func,
  playerControlState: PropTypes.string,
  portalRef: PropTypes.string,
  promo: PropTypes.shape({}),
  promoDisabled: PropTypes.bool,
  setGlobalPortalRef: PropTypes.func,
  setGlobaPortalContentFinished: PropTypes.func,
  video: PropTypes.shape({}),
  visibility: PropTypes.bool,
};

const mapStateToProps = ({
  globalVideo: { isPortalContentFinished, portalRef, screenInControlOfState: playerControlState },
}) => ({
  isPortalContentFinished,
  playerControlState,
  portalRef,
});

const mapDispatchToProps = {
  setGlobalPortalRef,
  setGlobaPortalContentFinished,
  setGlobalVideoControl,
  setGlobalVideoDisabled,
  setGlobalVideoPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextPlayer);
